import React, { useRef, useState } from "react";
import ListPageHeader from "../utilities/ListPageHeader";
import { Button, Card, Grid, Tab, Tabs, Tooltip, Stack, Typography } from "@mui/material";
import { AgChartsReact } from "ag-charts-react";
import AgGridTable from "../utilities/AgGridTable";
import { useEffect } from "react";
import oAuthServiceConfig from "src/app/auth/services/oAuthService/oAuthServiceConfig";
import OAuthService from "src/app/auth/services/oAuthService";
import FuseSvgIcon from "@fuse/core/FuseSvgIcon";
import Select from "react-select";
import { Link, useNavigate } from "react-router-dom";
import customStyles from "app/shared-components/SelectCustomStyle";
import moment from "moment";
import jwtDecode from "jwt-decode";


const LeaveOverView = () => {
    // const dummyData = [{  transferreddays: "20.5", current: "24", leaveprocessingstatus: "Completed", utilizationstatus: "Used", totaldaysentitled: "20.5", leavesconsumed: "3", remainingdays: "17.5" },
    // { from: "27-05-2023", to: "30-05-2023", transferreddays: "20.5", current: "24", leaveprocessingstatus: "Completed", totaldaysentitled: "20.5", leavesconsumed: "3",},]

    const gridRef = useRef();
    const navigate = useNavigate();
    const [date, setDate] = useState(new Date());
    const [tabValue, setTabValue] = useState(0);
    const [gridApi, setGridApi] = useState();
    const [searchValue, setSearchValue] = useState();
    const [currentEmp, setCurrentEmp] = useState();
    const [leaveType, setLeaveType] = useState();
    const [leaveTypeOptions, setLeaveTypeOptions] = useState([]);
    const [successMsg, setSuccessMsg] = useState();
    const [snackState, setSnackState] = useState(false);
    const [selectedRows, setSelectedRows] = useState([]);
    const [error, setError] = useState()
    const [pieTotalLeave, setpieTotalLeave] = useState(0)
    const LeaveUrl = `${process.env.REACT_APP_HR_API_KEY_URL}${oAuthServiceConfig.leave}`;
    const leaveEntitlements = `${process.env.REACT_APP_HR_API_KEY_URL}${oAuthServiceConfig.leaveEntitlements}`;
    const leaveInfoesUrl = `${process.env.REACT_APP_HR_API_KEY_URL}${oAuthServiceConfig.leaveInfoes}`;
    const token = (localStorage && localStorage.getItem('token')) && jwtDecode(localStorage.getItem('token'));

    const [option, setOption] = useState({
        theme: 'ag-default-dark',
        series: [
            {
                type: 'pie',
                calloutLabelKey: 'Leave',
                angleKey: 'days',
                innerRadiusRatio: 0.5,
                calloutLabel: {
                    enabled: false,
                },
            },
        ],
        legend: {
            data: leaveTypeOptions,
        },
        background: {
            fill: '#2A2E32',
        },
        title: {
            text: 'Types of Leave Taken',
            fontSize: 18,
            spacing: 25,
            color: "white"
        },
    });

    const [groupOption, setGroupOption] = useState({
        theme: 'ag-default-dark',
        title: {
            text: 'Total Leaves Taken',
            fontSize: 18,
            spacing: 25,
            color: "white"
        },
        background: {
            fill: '#2A2E32',
        },
    })

    const [barChartOption, setBarChartOption] = useState({
        theme: 'ag-default-dark',
        title: {
            text: 'Types of leaves ',
            fontSize: 18,
            spacing: 25,
            color: "white"
        },
        series: [
            {
                type: 'bar',
                xKey: 'Leave',
                yKey: 'days',
            },
        ],
        background: {
            fill: '#2A2E32',
        },
        legend: {
            enabled: false,
        },
    })

    const [columnDefs, setColumnDefs] = useState([
        { field: 'fromDate', enableRowGroup: true, headerName: 'From', minWidth: 180, },
        { field: 'toDate', enableRowGroup: true, headerName: 'To', minWidth: 180, },
        { field: 'noOfDays', enableRowGroup: true, headerName: 'Transferred Days', minWidth: 180, },
        { field: 'noOfDays', enableRowGroup: true, headerName: 'Current ', minWidth: 180, },
        { field: 'leaveApprvlStatus', enableRowGroup: true, headerName: 'Leave Processing Status', minWidth: 280, },
        { field: 'leavePlan', enableRowGroup: true, headerName: 'Utilization Status', minWidth: 280, },
        { field: 'noOfDays', enableRowGroup: true, headerName: 'Total Days Entitled', minWidth: 180, },
        { field: 'leaveTaken', enableRowGroup: true, headerName: 'Leaves Consumed', minWidth: 230, },
        { field: 'remainingDays', enableRowGroup: true, headerName: 'Remaining Days', minWidth: 230, },
    ])
    const [rowData, setRowData] = useState([])


    const currentYear = moment(date).format("YYYY");
    const currentMonth = date.getMonth();

    const loadOverViewData = async () => {
        setTabValue(currentMonth)
        try {
            let FilterData = {};
            if (leaveType) {
                FilterData = {...FilterData , leaveCategory: leaveType}
            }
            if(currentEmp.employeeId){
                FilterData = {...FilterData , empId: currentEmp.employeeId}
            }
            if(currentYear){
                FilterData = {...FilterData , year: [currentYear]}
            }

            const listData = await OAuthService.addData(LeaveUrl + `/getempleaveinfo`, FilterData)
            if (listData?.data) {
                const list = listData?.data?.map((data) => {
                    data.remainingDays = data.leaveType.remainingDays,
                        data.leaveTaken = data.leaveType.leaveTaken,
                        data.noOfDays = data.leaveType.noOfDays,
                        // data.carryFarward = data.leaveType.carryFarward,
                        data.noOfDays = data.leaveType.noOfDays
                    // data
                    return data
                })
                setRowData(list)
            } else {
                setRowData([])
            }
        } catch (error) {
            setError(error?.response?.data?.errorMessage || error.message)
        }

        const pieChart = await OAuthService.getList(leaveEntitlements + `/search/findByEmployeeIdAndYear?employeeId=${currentEmp?.employeeId}&year=${currentYear}`)
        try {
            const listPieChart = pieChart?.data.leaveTypes.map((data) => {
                return {
                    Leave: data.leaveType,
                    days: data.remainingDays
                };
            })
            // const totalLeaveCount = listPieChart.reduce((total, item) => total + item.days, 0);
            // setpieTotalLeave(totalLeaveCount)
            // setOption((prevOption) => ({
            //     ...prevOption,
            //     data: listPieChart,
            //     footnote: {
            //         text: `${totalLeaveCount} Leaves Taken`,
            //         color: "white",
            //     }
            // }));
            setBarChartOption((prevOption) => ({
                ...prevOption,
                data: listPieChart
            }))
        } catch (error) {
            setError(error?.response?.data?.errorMessage || error.message)
        }
      
        let FilterData = {};
        if (leaveType) {
            FilterData = {...FilterData , leaveCategory: leaveType}
        }
        if(currentEmp.employeeId){
            FilterData = {...FilterData , empId: currentEmp.employeeId}
        }
        if(currentYear){
            FilterData = {...FilterData , year: [currentYear]}
        }
        if(currentMonth){
            FilterData = {...FilterData , month: [currentMonth + 1]}
        }
        const groupChart = await OAuthService.addData(LeaveUrl + `/getempleaveinfo`, FilterData);
        console.log(groupChart);
        try {
            let leaveList = {};
            const monthsList = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
            let seriesList = []
            leaveTypeOptions.map((leave) => {
                leaveList = { ...leaveList, [leave.value]: 0 };
                seriesList.push({ type: 'column', xKey: 'months', yKey: [leave.value] })
                return leave;
            })
            let monthLeaves = []
            monthLeaves = monthsList.map((mon, i) => {
                let data = { months: mon, monthNo: i, ...leaveList }
                return data;
            })
            if (groupChart?.data) {
                groupChart?.data.map((data) => {
                    if (data.leaveType.leaveCategory.category) {
                        monthLeaves.map((mon) => {
                            if (mon.monthNo === currentMonth) {
                                mon[data.leaveType.leaveCategory.category] = data.leaveType.leaveTaken;
                            }
                            return mon;
                        })
                    }
                    return data;
                })
                setGroupOption((prevOption) => ({
                    ...prevOption,
                    data: monthLeaves,
                    series: seriesList
                }));
            }
            else {
                setGroupOption((prevOption) => ({
                    ...prevOption,
                    data: [],
                    series: seriesList
                }));
            }

        } catch (error) {
            setError(error?.response?.data?.errorMessage || error.message)
        }
        try {
            if (groupChart?.data) {
                let pieChartData = groupChart?.data.map((data) => {
                    return {
                        Leave: data.leaveType.leaveType,
                        days: data.leaveType.leaveTaken
                    };
                })
                console.log(pieChartData);

                const totalLeaveCount = pieChartData.reduce((total, item) => total + item.days, 0);
                setpieTotalLeave(totalLeaveCount)
                setOption((prevOption) => ({
                    ...prevOption,
                    data: pieChartData,
                    footnote: {
                        text: `${totalLeaveCount} Leaves Taken`,
                        color: "white",
                    }
                }));
            } else {
                setOption((prevOption) => ({
                    ...prevOption,
                    data: [],
                    footnote: {
                        text: `0 Leaves Taken`,
                        color: "white",
                    }
                }));
            }

        } catch (error) {
            setError(error?.response?.data?.errorMessage || error.message)
        }
    }

    useEffect(() => {
        loadOverViewData();
    }, [currentEmp, leaveType, currentMonth])

    console.log(leaveTypeOptions);

    const handleTabChange = async (event, value) => {
        setTabValue(value);
        try {
            let FilterData = {};
            if (leaveType) {
                FilterData = {...FilterData , leaveCategory: leaveType}
            }
            if(currentEmp.employeeId){
                FilterData = {...FilterData , empId: currentEmp.employeeId}
            }
            if(currentYear){
                FilterData = {...FilterData , year: [currentYear]}
            }
            if(value){
                FilterData = {...FilterData , month: [value + 1]}
            }
            const listData = await OAuthService.addData(LeaveUrl + `/getempleaveinfo`,FilterData);
            if (listData?.data) {
                const list = listData?.data?.map((data) => {
                    data.remainingDays = data.leaveType.remainingDays,
                        data.leaveTaken = data.leaveType.leaveTaken,
                        data.noOfDays = data.leaveType.noOfDays,
                        data.carryFarward = data.leaveType.carryFarward
                    // data
                    return data
                })
                setRowData(list)
            } else {
                setRowData([])
            }
        } catch (error) {
            setError(error?.response?.data?.errorMessage || error.message)
        }
        let FilterData = {};
        if (leaveType) {
            FilterData = {...FilterData , leaveCategory: leaveType}
        }
        if(currentEmp.employeeId){
            FilterData = {...FilterData , empId: currentEmp.employeeId}
        }
        if(currentYear){
            FilterData = {...FilterData , year: [currentYear]}
        }
        if(value){
            FilterData = {...FilterData , month: [value + 1]}
        }
        const groupChart = await OAuthService.addData(LeaveUrl + `/getempleaveinfo`, FilterData);

        try {
            let leaveList = {};
            const monthsList = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
            let seriesList = []
            leaveTypeOptions.map((leave) => {
                leaveList = { ...leaveList, [leave.value]: 0 };
                seriesList.push({ type: 'column', xKey: 'months', yKey: [leave.value] })
                return leave;
            })
            let monthLeaves = []
            monthLeaves = monthsList.map((mon, i) => {
                let data = { months: mon, monthNo: i, ...leaveList }
                return data;
            })
            if (groupChart?.data) {
                groupChart?.data.map((data) => {
                    if (data.leaveType.leaveCategory.category) {
                        monthLeaves.map((mon) => {
                            if (mon.monthNo === value) {
                            mon[data.leaveType.leaveCategory.category] = data.leaveType.leaveTaken;
                            }
                            console.log(mon);
                            return mon;
                        })
                    }
                    return data;
                })
                setGroupOption((prevOption) => ({
                    ...prevOption,
                    data: monthLeaves,
                    series: seriesList
                }));
            }
            else {
                setGroupOption((prevOption) => ({
                    ...prevOption,
                    data: [],
                    series: seriesList
                }));
            }

        } catch (error) {
            setError(error?.response?.data?.errorMessage || error.message)
        }
        try {
            if (groupChart?.data) {
                let pieChartData = groupChart?.data.map((data) => {
                    return {
                        Leave: data.leaveType.leaveType,
                        days: data.leaveType.leaveTaken
                    };
                })
                const totalLeaveCount = pieChartData.reduce((total, item) => total + item.days, 0);
                setpieTotalLeave(totalLeaveCount)
                setOption((prevOption) => ({
                    ...prevOption,
                    data: pieChartData,
                    footnote: {
                        text: `${totalLeaveCount} Leaves Taken`,
                        color: "white",
                    }
                }));
            } else {
                setOption((prevOption) => ({
                    ...prevOption,
                    data: [],
                    footnote: {
                        text: `0 Leaves Taken`,
                        color: "white",
                    }
                }));
            }

        } catch (error) {
            setError(error?.response?.data?.errorMessage || error.message)
        }
    }

    const onSelectionChanged = (params) => {
        setSelectedRows(params.api.getSelectedRows());
    }

    const onGridReady = (params) => {
        setGridApi(params.api);
    };

    useEffect(() => {
        const loadAllLeaveType = async () => {
            const url = `${process.env.REACT_APP_HR_API_KEY_URL}${oAuthServiceConfig.leaveCategories}`;
            try {
                const list = await OAuthService.getList(url);
                if (list?.data) {
                    const allCat = list?.data?._embedded?.leaveCategories.map((data) => {
                        return { label: data.category, value: data.category }
                    })
                    setLeaveTypeOptions(allCat)
                }

            } catch (error) {

            }
        }
        loadAllLeaveType();

        const getCurrentEmployee = async () => {
            const url = `${process.env.REACT_APP_HR_API_KEY_URL}${oAuthServiceConfig.employees}`;
            const email = token?.email;

            const emp = await OAuthService.getList(url + `/search/findEmployeeByEmail?email=${email}`);
            setCurrentEmp(emp?.data)
        }
        getCurrentEmployee();
        loadOverViewData();
    }, [])

    const handleSearchBarChange = (value) => {
        setLeaveType(value.value);
        handleTabChange(value)
        loadOverViewData()
    };

    const onRowDoubleClicked = () => {
        navigate("/LeaveManagementForm/" + selectedRows[0]?.leaveInfoId)
    }

    const LeaveOverViewFilter = () => {
        return <>
            <Select
                name="search"
                className=" min-w-[150px] h-[30px]"
                value={(leaveType && leaveTypeOptions.length > 0) && leaveTypeOptions.filter((data) => data.value === leaveType)}
                onChange={handleSearchBarChange}
                options={leaveTypeOptions}
                styles={customStyles('', '', '0px')}
            />

            <Tooltip title={"Add Leave"}>
                <Link to={"/LeaveManagementForm"} className="nav-link">
                    <Button
                        variant="contained"
                        color="warning"
                    >
                        <FuseSvgIcon>heroicons-solid:plus-circle</FuseSvgIcon>
                    </Button>
                </Link>
            </Tooltip >

            <Tooltip title={"Calender Leave"}>
                <Link to={"/LeaveCalendar"} className="nav-link">
                    <Button
                        variant="contained"
                        color="warning"
                    // onClick={handleCalenderLeave}
                    >
                        <FuseSvgIcon>material-outline:calendar_today</FuseSvgIcon>
                    </Button>
                </Link>
            </Tooltip>
        </>

    };


    return (
        <>
            <ListPageHeader
                componentName="Leave Overview"
                headerInputFields={LeaveOverViewFilter()}
                pageName="Leave Overview"
                successMsg={successMsg}
                snackState={snackState}
                gridRef={gridRef}
                showPaginationDropdown={false}
            />
            <Card className="mt-16 w-full self-center overflow-visible">
               <Tabs
                    value={tabValue}
                    onChange={handleTabChange}
                    textColor="inherit"
                    sx={{ '.Mui-selected': { backgroundColor: '#FFA726 !important', color: 'white !important', fontWeight: "bold !important" }, '.MuiTabs-scroller': { display: 'flex', justifyContent: 'center' } }}
                    variant="scrollable"
                    scrollButtons="auto"
                    classes={{ root: 'w-full' }}
                >
                    <Tab label={<Typography className={"px-28 text-lg"} >Jan<br />{currentYear}</Typography>} sx={{ color: 'text.secondary' }} />
                    <Tab label={<Typography className={"px-28 text-lg"} >Feb<br />{currentYear}</Typography>} sx={{ color: 'text.secondary' }} />
                    <Tab label={<Typography className={"px-28 text-lg"} >Mar<br />{currentYear}</Typography>} sx={{ color: 'text.secondary' }} />
                    <Tab label={<Typography className={"px-28 text-lg"} >Apr<br />{currentYear}</Typography>} sx={{ color: 'text.secondary' }} />
                    <Tab label={<Typography className={"px-28 text-lg"} >May<br />{currentYear}</Typography>} sx={{ color: 'text.secondary' }} />
                    <Tab label={<Typography className={"px-28 text-lg"} >Jun<br />{currentYear}</Typography>} sx={{ color: 'text.secondary' }} />
                    <Tab label={<Typography className={"px-28 text-lg"} >Jul<br />{currentYear}</Typography>} sx={{ color: 'text.secondary' }} />
                    <Tab label={<Typography className={"px-28 text-lg"} >Aug<br />{currentYear}</Typography>} sx={{ color: 'text.secondary' }} />
                    <Tab label={<Typography className={"px-28 text-lg"} >Sep<br />{currentYear}</Typography>} sx={{ color: 'text.secondary' }} />
                    <Tab label={<Typography className={"px-28 text-lg"} >Oct<br />{currentYear}</Typography>} sx={{ color: 'text.secondary' }} />
                    <Tab label={<Typography className={"px-28 text-lg"} >Nov<br />{currentYear}</Typography>} sx={{ color: 'text.secondary' }} />
                    <Tab label={<Typography className={"px-28 text-lg"} >Dec<br />{currentYear}</Typography>} sx={{ color: 'text.secondary' }} />
                </Tabs>

            </Card>

            <div className={'h-full flex flex-col space-y-16 sm:space-y-0 px-24 md:px-16 mt-10 '}>
                <Grid container spacing={2}>
                    <Grid item xs={6}>
                        <div className="h-auto" >
                            <AgChartsReact options={option} />
                        </div>

                    </Grid>
                    <Grid item xs={6}>
                        <div className="h-auto" >
                            <AgChartsReact options={groupOption} />
                        </div>
                    </Grid>
                </Grid >
                <Grid container className="h-full" spacing={2} >
                    <Grid item xs={4}>
                        {/* <div className="h-full" > */}
                        <div className=" h-[100%]" >
                            <AgChartsReact options={barChartOption} />
                        </div>
                        {/* </div> */}
                    </Grid>
                    <Grid item xs={8}>
                        {/* <div className="h-full" > */}
                        <div className="h-full " >
                            <AgGridTable
                                rowData={rowData}
                                columnDefs={columnDefs}
                                onGridReady={onGridReady}
                                onSelectionChanged={onSelectionChanged}
                                onRowDoubleClicked={onRowDoubleClicked}
                            />
                        </div>
                        {/* </div> */}
                    </Grid>
                </Grid>

            </div >



        </>
    )
}
export default LeaveOverView